import {defineMessages} from 'react-intl';

export default defineMessages({
  presenceError: {
    defaultMessage: 'You must agree to terms of service',
    id: 'Forms.Components.AdditionalTermsOfService.PresenceError',
  },
});
